/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComparisonStatus } from './ComparisonStatus';
import {
    ComparisonStatusFromJSON,
    ComparisonStatusFromJSONTyped,
    ComparisonStatusToJSON,
    ComparisonStatusToJSONTyped,
} from './ComparisonStatus';

/**
 * Request to update comparison status
 * @export
 * @interface UpdateComparisonStatusRequest
 */
export interface UpdateComparisonStatusRequest {
    /**
     * 
     * @type {ComparisonStatus}
     * @memberof UpdateComparisonStatusRequest
     */
    status?: ComparisonStatus;
    /**
     * Human-readable status message
     * @type {string}
     * @memberof UpdateComparisonStatusRequest
     */
    statusMessage?: string;
    /**
     * Error message if processing failed
     * @type {string}
     * @memberof UpdateComparisonStatusRequest
     */
    errorMessage?: string;
}



/**
 * Check if a given object implements the UpdateComparisonStatusRequest interface.
 */
export function instanceOfUpdateComparisonStatusRequest(value: object): value is UpdateComparisonStatusRequest {
    return true;
}

export function UpdateComparisonStatusRequestFromJSON(json: any): UpdateComparisonStatusRequest {
    return UpdateComparisonStatusRequestFromJSONTyped(json, false);
}

export function UpdateComparisonStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateComparisonStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ComparisonStatusFromJSON(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function UpdateComparisonStatusRequestToJSON(json: any): UpdateComparisonStatusRequest {
    return UpdateComparisonStatusRequestToJSONTyped(json, false);
}

export function UpdateComparisonStatusRequestToJSONTyped(value?: UpdateComparisonStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ComparisonStatusToJSON(value['status']),
        'statusMessage': value['statusMessage'],
        'errorMessage': value['errorMessage'],
    };
}

